// !!! IMPORTANT !!!
// For this to work, you must npm install mapboxgl with npm install mapbox-gl
// Doing so will give you access to the mapboxgl module and styles

/* eslint-disable */

//How to get the data:
//Find correct spreadsheet (see jira or github Readme)
//convert to json (Mr Data Converter)
//clean up Mr Data Converter results (turn seasonal? column to string)
//Paste into a json
//Component uses npm geojson to convert json to geojson

import MapListBuilder from '../helpers/maplistbuilder';
import MapStoryBuilder from '../helpers/mapstorybuilder';
import BuildMap from '../helpers/buildMap';

import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// eslint-disable-next-line import/no-unresolved
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';

import '~styles/modules/mapbox.scss';

//For converting json to geojson
//https://www.npmjs.com/package/geojson
var GeoJSON = require('geojson');

//mapbox variables
mapboxgl.accessToken = 'pk.eyJ1IjoiYm9zdG9uZ2xvYmUtbWFwYm94IiwiYSI6ImNrMXMzdzRjdzBjMTUzYmxnYWFicjk3dWkifQ.Pqincssv6-WMTdbuGiAyHw';

const MapWrapper = styled.div`
  position: relative;
`;

const Map = styled.div`
  width: 100%;
  height: 66vw;
  max-height: 90vh;
  margin: 2rem 0 0;
  @media(max-width: 800px) {
    height: 100vw;
    min-height: 400px;
  }
`;


const Mapbox = ({mapSource}) => {

  //Convert to geojson using geojson npm
  let mapData = GeoJSON.parse(mapSource, {Point: ['Latitude', 'Longitude']});

  // ----------------------------------------------------------------------
  // INITIAL MAP SETUP
  // Handles creating the mapbox map object, disabling zoom with scroll,
  // and adding new controls. Note, this does not run after mapRef.current
  // has been assigned the new mapbox map object
  // You can change the mapbox style by logging into our mapbox studio account
  // and getting a new style string (https://studio.mapbox.com/)
  // ----------------------------------------------------------------------

  const mapRef = useRef(null);
  const mapContainer = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [currentMap, updateMap] = useState(null);


  useEffect(() => {
    
    //Initial map set up
    if (mapRef.current) return;

    // eslint-disable-next-line
    mapRef.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/bostonglobe-mapbox/ck26bptfp1qr61dqlrpg34fo5',
      center: [-71.09, 42.32],
      zoom: 10.5,
    });

    let map = mapRef.current;

    //Disable default controls
    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl());
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();

    //rename currentMap variable
    {updateMap(map)}

    mapRef.current.on('load', function () {

      setMapLoaded(true);

      //Preload points using map data
      //BuildMap(map, "pointsLayer",mapData,"places")

    });
  
  }, []);


  //When map gets updated by parent component (FilterMap) and it's been lodaded, do stuff
  if (mapLoaded){

    let map = currentMap;

    BuildMap(map, "pointsLayer",mapData,"places")

  
  }

  //Place map and legent
  return (

    <MapWrapper id="map__wrapper" className="content">

      <MapListBuilder id="map__wrapper" className="content" dataSource={mapSource} />

      <Map id="map" ref={mapContainer} />

      <div id="map-legend">
        <div id="food-category" className="map-categories">FOOD</div>
        <div id="outdoors-category" className="map-categories">OUTDOORS</div>
        <div id="shopping-category" className="map-categories">SHOPPING</div>
        <div id="entertainment-category" className="map-categories">ENTERTAINMENT</div>
      </div>

    </MapWrapper>
  );
};

export default Mapbox;

Mapbox.propTypes = {
  mapRef: PropTypes.shape({
    current: PropTypes.shape({
      addControl: PropTypes.func.isRequired,
      on: PropTypes.func.isRequired,
      scrollZoom: PropTypes.shape({
        disable: PropTypes.func.isRequired,
      }).isRequired,
    }),
  }).isRequired,
  mapContainer: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
};
